import mijnkeuzeStore from '../../../../../templates/sections/mijnKeuze/store/store';

export default {
    props: {
        comparison: Object,
        receiver: String,
        marketType: {
            type: String,
            required: true,
            validator: (value) => ['internet', 'energy'].includes(value),
        },
    },
    mounted() {
        this.setValidityState();
        this.setValidityStateInput();
    },
    methods: {
        logEvent(event, eventData) {
            if (typeof window.bananas !== 'undefined') {
                window.bananas('event', `saveComparison.${event}`, eventData);
            }
        },
        setValidityState() {
            this.$el.querySelectorAll('input')
                .forEach((element) => {
                    element.setCustomValidity((this.error[element.name] ? 'error' : ''));
                });
        },
        setValidityStateInput() {
            this.$el.querySelectorAll('input')
                .forEach((element) => {
                    element.addEventListener('input', () => {
                        element.setCustomValidity('');
                    });
                    element.addEventListener('change', () => {
                        element.setCustomValidity((this.error[element.name] ? 'error' : ''));
                    });
                });
        },
        saveComparison() {
            document.activeElement.blur();

            let action = '';
            if (this.marketType === 'energy') {
                if (!this.signedIn) {
                    action = 'emailEnergyComparison';
                } else if (this.receiver === 'other') {
                    action = 'emailEnergyComparison';
                } else {
                    action = this.receiver === 'friend' ? 'saveEnergyComparisonForFriend' : 'saveEnergyComparison';
                }
            } else if (this.marketType === 'internet') {
                if (!this.signedIn) {
                    action = 'emailInternetComparison';
                } else if (this.receiver === 'other') {
                    action = 'emailInternetComparison';
                } else {
                    action = this.receiver === 'friend' ? 'saveInternetComparisonForFriend' : 'saveInternetComparison';
                }
            }
            this.logEvent('saveComparison', {
                action,
                signedIn: this.signedIn,
            });
            mijnkeuzeStore.dispatch(action, this.comparison)
                .then((response) => {
                    if (window.bananas) {
                        window.bananas('event', 'mijnkeuze.save-comparison', {
                            type: this.marketType,
                            id: response.saved_comparison.id,
                            timestamp: Date.now(),
                        });
                    }
                    this.logEvent('success', {
                        comparison: response.saved_comparison,
                        signedIn: this.signedIn,
                    });
                    this.$emit('complete', response.saved_comparison);
                })
                .catch(() => { // Force empty error state
                    Object.keys(this.error)
                        .forEach((key) => {
                            document.querySelectorAll(`input#${key}`)
                                .forEach((inputElement) => {
                                    inputElement.removeAttribute('placeholder');
                                });
                        });
                    this.logEvent('error', {
                        comparison: this.comparison,
                        signedIn: this.signedIn,
                    });
                    this.$emit('previousStep');
                });
        },
    },
    watch: {
        error: {
            handler(errors) {
                this.$el.querySelectorAll('input')
                    .forEach((element) => {
                        element.setCustomValidity((errors[element.name] ? 'error' : ''));
                    });
            },
            deep: true,
        },
        comparison: {
            handler(comparison) {
                mijnkeuzeStore.dispatch('validateComparison', comparison);
            },
            deep: true,
        },

    },
    computed: {
        signedIn() {
            return mijnkeuzeStore.getters.tokenValid && !!mijnkeuzeStore.getters.account.email_address;
        },
        error: {
            get() {
                return mijnkeuzeStore.getters.error;
            },
        },
        friends: {
            get() {
                return mijnkeuzeStore.getters.friends.friends;
            },
        },
        computedComparison: {
            set(value) {
                this.$emit('update:comparison', value);
            },
            get() {
                return this.comparison;
            },
        },
        computedReceiver: {
            set(value) {
                this.$emit('update:receiver', value);
            },
            get() {
                return this.receiver;
            },
        },
        friendOptions: {
            get() {
                const options = [];
                Object.values(this.friends)
                    .forEach((friend) => {
                        options.push({
                            value: friend.id,
                            label: friend.name,
                        });
                    });
                return options;
            },
        },
        friendName() {
            let friendName = 'je vriend';
            if (this.comparison.friend_id) {
                Object.values(this.friendOptions)
                    .forEach((friend) => {
                        if (friend.value === this.comparison.friend_id) {
                            friendName = friend.label;
                        }
                    });
            }
            return friendName;
        },
        confirmFirstName() {
            return this.comparison.first_name ?? 'je vriend';
        },
        confirmEmailAddress() {
            return this.comparison.email_address ?? null;
        },
        showFriendFeature() {
            return this.signedIn && mijnkeuzeStore.getters.account.features.friends && this.friends.length > 0;
        },
        buttonLabel() {
            return this.receiver === 'self' ? 'Bewaar vergelijking' : 'Deel vergelijking';
        },
    },
};
